export default class e{constructor(){throw Error("Use `await Swiper.create()` instead of `new Swiper()`")}static async create(...e){let{default:t}=await import(/* @preserve
             * webpackChunkName: "scripts/hc_swiper_v11"
             * webpackMode: "weak"
             */"swiper-11/bundle");return await import(/* @preserve
             * webpackChunkName: "styles/hc_swiper_v11"
             * webpackMode: "weak"
             */"swiper-11/css/bundle"),new t(...e)}}